module.exports = __webpack_public_path__ + "img/Payouts.d2e97eda.svg";